/**
 * Norwegian (Bokmål) PDF Templates
 *
 * Export all Norwegian PDF templates from this index file.
 */

export { advisoryMultiPortfolioStandard } from "./advisory-multi-portfolio";
export { helloWorld } from "./hello-world";
